gsap.registerPlugin(ScrollTrigger);

const revealText = document.querySelectorAll('.reveal-p');

// メディアクエリで1021px以上のときだけアニメーションを適用
const isLargeScreen = window.matchMedia('(min-width: 1021px)').matches;

if (isLargeScreen) {
    revealText.forEach((char, i) => {
        const bg = char.dataset.bgColor;
        const fg = char.dataset.fgColor;
        const text = new SplitType(char, { types: 'chars' });

        const isHeightSmall = window.innerHeight <= 1000; // 高さが1000px以下かどうか

        // 条件に応じてstartValueとendValueを設定
        let startValue, endValue;

        if (isHeightSmall) {
            startValue = '4% 60%'; // アニメーション開始位置を要素の上から80%の位置に変更
            endValue = '85% 60%'; // アニメーション終了位置を要素の下から20%の位置に変更
        } else {
            startValue = '4% 60%'; // 通常の開始位置
            endValue = '85% 60%'; // 通常の終了位置
        }

        gsap.fromTo(
            text.chars,
            { color: bg },
            {
                color: fg,
                duration: 1.2, // 色が変わるまでの時間
                stagger: {
                    each: 0.03, // 各文字の間隔
                    ease: 'power1.inOut', // スムーズな変化
                },
                scrollTrigger: {
                    trigger: '.company__message-content', // スクロール範囲を指定
                    start: startValue,
                    end: endValue,
                    scrub: true,
                    // markers: true, // デバッグ用
                },
            }
        );
    });
}
